import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
// HOOK
import useAuth from "app/hooks/useAuth";

// Helper function to match URL with pattern





export default function AuthGuard({ children }) {
  const { user, isAuthenticated } = useAuth();
  const [previouseRoute, setPreviousRoute] = useState(null);
  const { pathname } = useLocation();

  useEffect(() => {
    // On component mount, retrieve the previous route from localStorage
    const storedRoute = localStorage.getItem("previouseRoute");

    // Set it in state if it's found in localStorage
    if (!previouseRoute && storedRoute) {
      setPreviousRoute(storedRoute);
    }

    // Always store the current pathname in localStorage for future redirects
    localStorage.setItem("previouseRoute", pathname);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional deps (preserve behavior)
  }, [pathname]);

  // Clear localStorage after successful authentication
  useEffect(() => {
    if (isAuthenticated && user) {
      // Clear previous route once user is authenticated
      localStorage.removeItem("previouseRoute");
    }
  }, [isAuthenticated, user]);

  if (isAuthenticated) {




    const forcePasswordChange = user.pwChangeRequired || false;

    if (forcePasswordChange) {
      return <Navigate replace to="/users/password-change" />;
    }

    // if (!isAccessible) {
    //   return <Navigate replace to="/not-authorized" />;
    // }

    return <>{children}</>;
  }

  return (
    <Navigate
      replace
      to="/session/signin"
      state={{ redirectUrl: previouseRoute || pathname }} />);


}